import { render } from "./GroupDetailsEL.vue?vue&type=template&id=6714b92c"
import script from "./GroupDetailsEL.vue?vue&type=script&lang=js"
export * from "./GroupDetailsEL.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__